import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NSButton } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import useAuthContext from 'contexts/AuthContext';
import { Link } from 'react-router-dom';
import { URLS } from 'services/urls';

interface ErrorPageProps {
    message?: string;
    buttonText?: string;
    buttonUrl?: string;
    icon?: IconDefinition;
}

const DEFAULT_MESSAGE = "You don't have access to this page. Contact a system administrator to request access.";

const ErrorPage = ({
    message = DEFAULT_MESSAGE,
    buttonText = 'Back to Deals',
    buttonUrl = URLS.DEALS.HOME,
    icon = faLock,
}: ErrorPageProps) => {
    const { role } = useAuthContext();
    return (
        <div className="text-center h-100 w-100 position-absolute d-flex flex-column justify-content-center">
            <FontAwesomeIcon icon={icon} className="mb-1 text-white" size="5x" />
            <h2 className="text-white">{message}</h2>
            <RenderIf isTrue={!!role}>
                <NSButton dataTestId="back-to-deals-btn" outline={false} color="secondary" className="d-block mx-auto">
                    <Link to={buttonUrl} className="text-white">
                        {buttonText}
                    </Link>
                </NSButton>
            </RenderIf>
        </div>
    );
};

export default ErrorPage;
